import * as React from 'react'
import { Fragment } from 'react';
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { Row, Col, Card, CardImg, CardTitle, CardText, CardGroup,
    CardSubtitle, CardBody, Spinner, ListGroup, ListGroupItem, Button, 
    Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Table, Modal, ModalHeader, ModalBody, ModalFooter, Label  } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import BlobUtil from '../../utils/blobUtil'
import { Link } from 'react-router-dom';
import { Item } from '@azure/cosmos';
import { FaInfoCircle  } from 'react-icons/fa';
import { GeneralUtil } from '../../utils/generalUtil';
import { animatedScrollTo } from 'react-select/src/utils';

const generalUtil: GeneralUtil = new GeneralUtil();

interface IState {
    modal: boolean
    searchSorting : string
    searchSortingDisplay : string
    searchSortingDropDownOpen : boolean
    redirect: boolean
    redirectId: string
    downloadingInvoice:boolean
}
// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    totalDocument : number
    offset : number
    limit : number
    data: any[]
    loading: boolean
    firstLoad: boolean
    user : any
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    onLoadMore: any
    onSorting:any
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch;


class MyCourseList extends React.Component<AllProps, IState> {

    /**
     *
     */
    blobUtil: BlobUtil;

    constructor(props: AllProps) {
        super(props);
        this.state = {
            modal: false,
            searchSortingDisplay: "Title",
            searchSorting: "",
            searchSortingDropDownOpen: false,
            redirect: false,
            redirectId : "",
            downloadingInvoice : false
        };

        this.blobUtil = new BlobUtil();
        //this.onInputChange = this.onInputChange.bind(this);
        this.onChangeSorting = this.onChangeSorting.bind(this);
        this.downloadInvoice = this.downloadInvoice.bind(this);
    }
    public componentDidMount() {
        
    }
    componentDidUpdate(prevProps: AllProps) {

    }

    onChangeSorting(e:any){
        var sortText = e.currentTarget.textContent;
        var sortExpression = "";
        switch(sortText) {
            case "Title":
                sortExpression  = "c.titleLowercase";
                break;
            case "Newest":
                sortExpression  = "c.publishedDT DESC";
                break;
            // case "Lowest CPD Point":
            //     sortExpression  = "c.cpdPoints";
            //     break;
            // case "Highest CPD Point":
            //     sortExpression  = "c.cpdPoints DESC";
            //     break;
            case "Shortest Video":
                sortExpression  = "c.duration";
                break;
            case "Longest Video":
                sortExpression  = "c.duration DESC";
                break;
            case "Trainer":
                sortExpression  = "c.trainer.name";
                break;
            case "Lowest Price":
                sortExpression  = "c.normalPrice";
                break;
            case "Highest Price":
                sortExpression  = "c.normalPrice DESC";
                break;
            default:
                sortExpression  = "c.titleLowercase";
          }

        this.setState({ searchSortingDisplay : sortText, searchSorting: sortExpression}, () => {
            this.props.onSorting(this.state);
        }
    )
    }

    SecondsTohhmmss(totalSeconds:number) {
        if (totalSeconds < 0){
            return "-";
        }

        totalSeconds = Math.trunc(totalSeconds);
        var hours   = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds - (hours * 3600)) / 60);
        var seconds = totalSeconds - (hours * 3600) - (minutes * 60);
      
        // round seconds
        seconds = Math.round(seconds * 100) / 100
      
        var result = (hours < 10 ? "0" + hours : hours);
            result += ":" + (minutes < 10 ? "0" + minutes : minutes);
            result += ":" + (seconds  < 10 ? "0" + seconds : seconds);
        if (result === "00:00:00"){
            result = "-";
        }
        return result;
    }

    ExpiryDate(date: Date, days: number) {
        var expiryDate = new Date(date);
        //expiryDate.setDate(expiryDate.getDate() + days);
        expiryDate.setDate(expiryDate.getDate() + parseInt(String(days)));
        //console.log("Test:" + expiryDate);
        //var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        var options = { year: 'numeric', month: 'short', day: 'numeric' } as const;
        return expiryDate.toLocaleDateString("en-US", options);
    }

    DaysRemaining(date: Date, days: number) {
        var expiryDate = new Date(date);
        //expiryDate.setDate(expiryDate.getDate() + days);
        expiryDate.setDate(expiryDate.getDate() + parseInt(String(days)));
        var today = new Date();
        if (expiryDate > today){
            const diffTime = Math.abs(expiryDate.getTime() - today.getTime());
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
            return diffDays + " day(s)";
        }else{
            return "-";
        }
    }

    onRowSelected(id:string, e:any){
        //console.log("Course ID:" +courseId);
        this.setState({redirect : true, redirectId: id}, () => {
        });
    }

    constructCPDPoint(array: any) {
        let data: any = [];
        if (array && array.length > 0){
            array.forEach((e: any) => {
                data.push(e.cpdRefNo + " (" + e.points + ")");
                // data.push("Engineer: 123");
            });
        }

        return data.join("\r\n");
    }
    
    async getCertUrl(certFileName:string) {
        let blobRequestUrl = await this.blobUtil.GetBlob(certFileName);
        return blobRequestUrl;
    }

    async downloadCert(certFileName:string){
        let certURL = await this.getCertUrl(certFileName);
        //console.log("Cert URL:"+ certURL);
        if (this.props.user.userStatus === "Pending Approval"){
            alert("Your account is still pending approval.");
        } else{
            window.open(certURL);
        }
    }

    GetImagePath(fileName: string){
        if (fileName && fileName != ''){
            fileName = fileName.replace("/courses/","").replace(".jpg","_xs.jpg");
            return "https://images.ultimatespro.com/images/" + fileName;
        } else {
            return "https://images.ultimatespro.com/images/general/empty.png";
        }
    }
    
    async downloadInvoice(orderNo:string){
        this.setState({downloadingInvoice : true});
        let orderRecord = await generalUtil.ReadOrderByOrderNo(orderNo);
        if (orderRecord.isSuccess){
            let fileName = orderRecord.doc.id + "-inv.pdf";
            let invoiceURL = await this.getInvoiceUrl(fileName);
            //console.log("Invoice URL:"+ invoiceURL);
            window.open(invoiceURL);
        }
        this.setState({downloadingInvoice : false});
    }

    async getInvoiceUrl(fileName:string) {
        let blobRequestUrl = await new BlobUtil().GetBlob(fileName);
        return blobRequestUrl;
    }

    public render() {   
        const tdStyle = {
             padding : "15px"
          };

        const showLoadMore = (this.props.offset + this.props.limit) < this.props.totalDocument;
        const toggleSortingDropDown = () => this.setState({searchSortingDropDownOpen : !this.state.searchSortingDropDownOpen}); 

        const renderCertColumn = (item:any) => {
            var expiryDate = new Date(item.orderDT);
            //expiryDate.setDate(expiryDate.getDate() + item.shelfLifeDays);
            expiryDate.setDate(expiryDate.getDate() + parseInt(String(item.shelfLifeDays)));
            var today = new Date();

            if(item.feedbackSubmitted){
                // Feedback Submitted, check if cert generated
                if (item.certIsGenerated){
                    // if (this.props.user.userStatus === "Pending Approval"){
                    //     return <Button color="secondary" 
                    //         onClick={this.downloadCert.bind(this, item.certFileName)} block
                    //         hidden={!item.certIsGenerated} disabled = {true} >
                    //         Download
                    //     </Button>;
                    // }else{
                    return <Button color="secondary" 
                        onClick={this.downloadCert.bind(this, item.certFileName)} block
                        hidden={!item.certIsGenerated} >
                        Download
                    </Button>;
                   // }
                }else{
                    return <span>Generating Cert</span>;
                }
            }else{
                if (item.courseDuration != 0 && item.playUntilSeconds >= item.courseDuration){
                   // Course completed but feedback not submitted, redirect to fill in feedback
                    return <Fragment>
                    <Link title="Feedback is required upon generating certificate" to={'/mycourses/feedback/' + item.id} className="btn btn-primary" ><FaInfoCircle title="Feedback is required upon generating certificate"/>Feedback</Link>
                    </Fragment>;
                    
                }else{
                    if (expiryDate < today){
                        return <span>Ineligible</span>;
                    }else{
                        return <span>Pending</span>;
                    }
                }
            }
        };    

        const renderStatus = (item:any) => {
            var remaining =  item.courseDuration - item.playUntilSeconds

            var expiryDate = new Date(item.orderDT);
            //expiryDate.setDate(expiryDate.getDate() + item.shelfLifeDays);
            expiryDate.setDate(expiryDate.getDate() + parseInt(String(item.shelfLifeDays)));
            var today = new Date();
            
            // if (item.noTracking == true){
            //     return <span>No Tracking</span>
            // } else {
            if (item.playUntilSeconds == 0){
                return <span>New</span>
            }else{
                if (remaining > 0){
                    if (expiryDate < today){
                        return <span>Incomplete</span>
                    }else{
                        return <span>Watching</span>
                    }
                }else{
                    return <span>Completed</span>
                }
            }
            //}
        }
        const renderPlay = (item:any) => {
            var expiryDate = new Date(item.orderDT);
            //expiryDate.setDate(expiryDate.getDate() + item.shelfLifeDays);
            expiryDate.setDate(expiryDate.getDate() + parseInt(String(item.shelfLifeDays)));
            var today = new Date();
            if (expiryDate < today){
                return <span>Expired</span>
            }else{
                if (item.verificationType == "noVerification"){
                    return <div>
                        <img width='36px' src='data:image/svg+xml;base64,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' />
                        <Link to={'/mycoursesv/' + item.id} className="btn btn-success">Play</Link>
                    </div>
                } else{
                    return <div>
                        <img width='36px' src='data:image/svg+xml;base64,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' />    
                        <Link to={'/mycourses/' + item.id} className="btn btn-success">Play</Link>
                    </div>
                }
            }
        }

        if (this.state.redirect){
            return (
                <Redirect push to={{
                    pathname: '/mycourses/' + this.state.redirectId
                }} />
                // <Redirect to={"/courses/" + this.state.redirectCourseId } />
            )
        }
        else{
            return (
                // <div onScroll={this.props.onLoadMore.bind(this, this.state)}>
                <div>
                    {
                         <Table responsive >
                            <thead>
                                <tr style={{whiteSpace: "nowrap"}}>
                                    <th>#</th>
                                    {/* <th>Order #</th> */}
                                    {/* <th>Course Ref#</th> */}
                                    <th>CPD Ref/Points</th>
                                    {/* <th>Order#</th> */}
                                    <th>Remaining<br/>days</th>
                                    <th>Expiry Date</th>
                                    <th>Duration</th>
                                    <th>Remaining</th>
                                    <th>Status</th>
                                    <th>Course Video</th>
                                    <th>Certificate</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                this.props.data.length>0 ? (
                                    this.props.data.map(item =>(
                                        <Fragment key={item.id} >
                                             {/* {JSON.stringify(item)} */}
                                            {/* <tr key={item.id} onClick={this.onRowSelected.bind(this, item.id)}> */}
                                            <tr key={item.id + "-1"}>
                                                <th scope="row" rowSpan={3}>
                                                    <img src={this.GetImagePath(item.videoThumbnailURL)} width="100px" />
                                                </th>
                                                <td colSpan={10} style={{fontWeight: "bolder"}}>
                                                    {/* <Link to={'/mycourses/' + item.id}>{item.courseTitle}</Link> */}
                                                    {item.courseTitle}
                                                </td>
                                            </tr>
                                            <tr style={{backgroundColor:"#f1f1f1"}}>
                                                <td colSpan={1} style={{paddingTop:"2px", paddingBottom:"2px"}}>
                                                    <strong>Reference :</strong> {item.refNo}
                                                </td>
                                                <td colSpan={10} style={{paddingTop:"2px", paddingBottom:"2px"}}>
                                                    {item?.orderNo ? 
                                                        <div><strong>Order :</strong>
                                                            <Button color="default" onClick={this.downloadInvoice.bind(this, item?.orderNo)}>{item?.orderNo}&nbsp;&nbsp;<i className="fas fa-download mr-1"></i></Button>
                                                        </div>
                                                        :""
                                                    }
                                                </td>
                                            </tr>
                                            <tr key={item.id + "-2"}>
                                                <td style={{fontSize:"smaller"}}>
                                                    {this.constructCPDPoint(item.cpdPoints)}
                                                </td>
                                                <td>
                                                    {this.DaysRemaining(item.orderDT, item.shelfLifeDays)}
                                                </td>
                                                <td>
                                                    {this.ExpiryDate(item.orderDT, item.shelfLifeDays)}
                                                </td>
                                                <td>
                                                    {this.SecondsTohhmmss(item.courseDuration)}
                                                </td>
                                                <td>
                                                    {this.SecondsTohhmmss(item.courseDuration - item.playUntilSeconds)}
                                                </td>
                                                <td>
                                                    {renderStatus(item)}
                                                </td>
                                                <td>
                                                     {/* {JSON.stringify(item.verificationType)} */}
                                                    {renderPlay(item)}
                                                </td>
                                                <td>
                                                    {renderCertColumn(item)}
                                                </td>
                                            </tr>
                                        </Fragment>
                                    ))
                                    ) : (
                                        <Fragment>
                                            <tr><td colSpan={12}><span>Please subscribe to course</span></td></tr>
                                        </Fragment>
                                    )
                                }
                            </tbody>
                        </Table>
                    }
                    <br/><br/><br/><br/><br/><br/><br/><br/>
                    <Modal size="xs" isOpen={this.state.downloadingInvoice} unmountOnClose={true}>
                    <ModalHeader>Invoice</ModalHeader>
                    <ModalBody>
                        <Label>Downloading Invoice<Spinner color="warning"></Spinner></Label>
                    </ModalBody>
                </Modal>
                </div>
            )
        }
    }
    // toggleClose() {
    //     this.setState({
    //         modal: false
    //     })
    // }
    // toggleOpen() {
    //     this.setState({
    //         modal: true
    //     })
    // }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState) => ({
    
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps
)(MyCourseList) 